<template>
  <div class="index" v-loading="loading">
    <div class="index-con">
      <!-- <div class="con-info"> -->
      <div class="paper-info">
        <div class="con-info-title">Bank Transfer</div>
        <div class="paper-info-con">
          <div class="tip">
            <span class="bank-step">Step 1</span>
            Please transfer your registration fee to the following bank account
          </div>
          <div class="bank-con">
            <div class="bank-title">
              Jiangnan University Bank Account 1 (US Dollar Remittance)
            </div>
            <div class="bank-cons">
              <p class="bank-text text-red">Total: {{ totalNum ? totalNum : 0 }} USD</p>


              <p class="bank-text"> &nbsp; </p>


              <p class="bank-text"></p><b>Account with Bank:</b></p>
              <p class="bank-text"></p><b>* Name: </b> Bank of China, Wuxi Branch</p>
              <p class="bank-text"></p><b>* Address: </b> No.258 Zhongshan Road, Wuxi，214002，Jiangsu, P. R. China</p>
              <p class="bank-text"></p><b>* SWIFT CODE: </b> BKCHCNBJ95C</p>

              <p class="bank-text"> &nbsp; </p>
              <p class="bank-text"><b>Beneficiary: </b></p>
              <p class="bank-text"><b>* Name: </b> Jiangnan university</p>
              <p class="bank-text"><b>* Address: </b> No.1800 Lihu Road, Wuxi，214122,Jiangsu，P.R.China</p>
              <p class="bank-text"><b>* Account No. </b>: 474158228044</p>
              <p class="bank-text"><b>* Tel: </b> 0510-85913145</p>
            </div>
          </div>
          <div class="bank-con">
            <div class="bank-title">
              Jiangnan University Bank Account 2 (RMB Remittance)
            </div>
            <div class="bank-cons">
              <p class="bank-text text-red">Please use the exchange rate on the date of payment
              </p>
              <p class="bank-text"> &nbsp; </p>
              <p class="bank-text">
                <b>Account Name:</b> Jiangnan University(江南大学)
              </p>
              <p class="bank-text">
                <b>Account Bank:</b> Wuxi Jiangnan University Branch, Industrial and
                Commercial Bank of China(工商银行无锡江南大学支行)
              </p>
              <p class="bank-text">
                <b>Bank account number:</b> 1103 0307 0910 0000 136
              </p>
            </div>
          </div>
          <div class="tip">
            <span class="bank-step">Step 2</span>
            After payment, please upload the "Payment Voucher Screenshot", and it will be verified within ten days
            (Cross-border payments have a longer delay).


          </div>

          <div class="bank-con">
            <div class="bank-title">
              Payment voucher screenshot:
            </div>
            <div class="bank-cons">
              <!-- <p class="bank-text">
                <img v-if='report_url' :src="'https://www.ids2024.com/public/' + report_url" width="200px"
                  height="200px">
              </p>
              <el-upload accept=".png, .jpg,.jpeg" class="upload-demo" :on-success="successReport"
                :action="host + '/VisApi/uploadImg'" :on-exceed="onexceedFn" :before-upload="beforeAvatarUpload"
                :limit="1" :before-remove="removeReport" :file-list="fileList">
                <el-button size="small" type="success">+ Select Photo</el-button>
                <template>
                  <b style="color: #f00"> (".png" or ".jpg" or ".jpeg" file format only.) </b>
                </template>
</el-upload> -->
              <el-upload ref="child" :action="host + '/VisApi/uploadImg'" :on-success="successReport"
                :before-remove="removeReport" :file-list="imgList" accept=".png, .jpg,.jpeg"
                :before-upload="beforeAvatarUpload" :limit="10" list-type="picture-card" :on-exceed="onExceedFn">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />

                  <span class="el-upload-list__item-actions">
                    <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="" />
              </el-dialog>
            </div>
          </div>


          <div class="sub-mit" @click="tosubUpThen">Confirm</div>
        </div>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      host: "/api",
      loading: false,
      con: {},
      totalNum: 0,

      submissionType: "1",
      title: "",
      abstract: "",
      keywords: "",
      visitor_id: "",
      report_url: "",
      radio: 0,
      id: "",
      email: "",
      visitor_id: "",
      work_img_url: [],
      imgList: [],
    };
  },
  mounted() {
    var token = localStorage.getItem("token");
    this.visitor_id = localStorage.getItem("visitor_id");
    if (!token) {
      this.$router.push("/login");
      return;
    } else {
    }
    this.email = localStorage.getItem("email");
    this.getInfo();

  },
  methods: {

    onExceedFn() {
      this.$message.error("最多上传10个文件");
    },
    handleRemove(con) {
      console.log(con, "--=-=-=-");
      console.log(this.work_img_url, "-=-=-=-");
      console.log(this.imgList, "-=-=-=");
      console.log(this.$refs.child, "-=-=-==----");
      let url = con.response && con.response.data ? con.response.data : con.url;
      let name =
        con.response && con.response.data ? con.response.data : con.name;
      for (var i = 0; i < this.work_img_url.length; i++) {
        if (this.work_img_url[i] == name) {
          this.work_img_url.splice(i, 1);
        }
      }
      this.imgList.forEach((v, index) => {
        if (v == url || v.url == url) {
          this.imgList.splice(index, 1);
        }
      });
      this.$refs.child.uploadFiles.forEach((v, index) => {
        if (v.response && v.response.data && v.response.data == url) {
          this.$refs.child.uploadFiles.splice(index, 1);
        }
        if (v.url == url) {
          this.$refs.child.uploadFiles.splice(index, 1);
        }
      });
    },
    successReport(a, b) {
      this.work_img_url.push(a.data);
      this.imgList.push(a.data);
      this.$message.success("上传成功！");
      console.log(this.$refs.child, "p---");
      this.loading = false;
      if (a.code == 200) {
        this.$message.success("Upload successful");
      }
    },
    getInfo() {
      this.$http.get_info({
        visitor_id: this.visitor_id,
        email: this.email
      }).then(res => {
        let con = res.data.data[0];
        con.Delegate_num = Number(con.Delegate_num)
        con.Student_num = Number(con.Student_num)
        con.Accompanying_num = Number(con.Accompanying_num)
        con.Banquet_num = Number(con.Banquet_num)

        con.Delegate_total = Number(con.Delegate_total)
        con.Student_total = Number(con.Student_total)
        con.Accompanying_total = Number(con.Accompanying_total)
        con.Banquet_total = Number(con.Banquet_total)

        this.totalNum = Number(con.total)
        this.con = con
        this.$nextTick(() => {
          // if (con.Payment_photo) {
          //   this.report_url = con.Payment_photo
          //   this.fileList.push({
          //     url: con.Payment_photo,
          //     name: con.Payment_photo,
          //   });
          // } else {
          //   this.fileList = []
          //   this.report_url = ''
          // }
          let urls = con.Payment_photo
            ? typeof con.Payment_photo == "object"
              ? con.Payment_photo
              : con.Payment_photo.split(",")
            : [];
          let imgList = [];
          for (var i = 0; i < urls.length; i++) {
            imgList.push({
              url: "https://www.ids2024.com/public/" + urls[i],
              name: urls[i],
            });
          }
          console.log(urls, "-09847678902-3098");
          this.imgList = imgList;
          this.work_img_url = urls;
        })
        console.log(res.data.data[0], '--------')
      })
      this.$nextTick(() => {
        if (con.Payment_photo) {

          this.fileList.push({
            url: con.Payment_photo,
            name: con.Payment_photo,
          });
        } else {
          this.fileList = []
        }
      })
    },
    removeReport(a) {
      if (a.response && a.response.data) {
        for (var i = 0; i < this.report_url.length; i++) {
          if (this.report_url[i] == a.response.data) {
            this.report_url.splice(i, 1);
          }
        }
      }
      console.log(this.report_url);
    },
    successReport(a, b) {
      this.work_img_url.push(a.data);
      this.imgList.push(a.data);
      this.$message.success("上传成功！");
      console.log(this.$refs.child, "p---");
      this.loading = false;
    },
    beforeAvatarUpload(rawFile) {
      if (rawFile.size > 1024 * 1024 * 3) {
        this.$message({
          message: "文件不能超过3M",
          type: "error",
        });
        return false;
      } else {
        this.loading = true;
        return true;
      }
    },
    tosubUpThen() {
      if (!this.work_img_url) {
        this.$message.error("please upload Payment voucher screenshot")
        return;
      }
      var params = {
        email: this.email,
        Payment_photo: this.work_img_url.toString(),
      };
      var that = this;
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$http.update_register_Payment(params).then((res) => {
        loading.close();
        if (res.code == 200) {
          that.$message.success("success");
          setTimeout(() => {
            that.$router.push("/loginThen");
          }, 500);
        } else {
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped>
.mt-20 {
  margin-top: 20px;
}

.bank-con {
  border: 1px solid #357ebd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.bank-title {
  background: #357ebd;
  color: #fff;
  padding: 15px;
}

.bank-text {
  margin-bottom: 4px;
}

.bank-text.text-red {
  color: #f00;
  font-weight: 600;
}

.bank-cons {
  padding: 15px;
  box-sizing: border-box;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding: 20px;
  box-sizing: border-box;
}

.con-info,
.paper-info {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
}

.con-info-title {
  border-bottom: 1px solid #ddd;
  background: #f5f5f5;
  padding: 15px;
  font-size: 18px;
  font-weight: 600;
  box-sizing: border-box;
}

.con-info-lists {
  padding: 20px;
  box-sizing: border-box;
}

.con-info-lists span {
  font-size: 24px;
  font-weight: 500;
}

.con-info-list-title {
  font-weight: 600;
  font-size: 18px;
}

.paper-info-con {
  padding: 20px;
  box-sizing: border-box;
}

.paper-info-title {
  font-size: 16px;
  font-weight: 600;
  padding: 15px 0;
  box-sizing: border-box;
}

.tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
}

.tip span {
  background: #5bc0de;
  padding: 7px 15px;
  border-radius: 5px;
  color: #fff;
}

.author {
  color: #31708f;
  font-weight: 600;
  margin-bottom: 15px;
}

.author span {
  color: #f00;
}

.author-lists {
  display: flex;
  flex-wrap: wrap;
}

.delete-btn {
  padding: 8px 25px;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  box-sizing: border-box;
  background: #f00;
}

.author-list {
  width: calc(25% - 20px);
  margin-right: 20px;
  margin-bottom: 20px;
}

.author-list:nth-of-type(4n) {
  margin-right: 0;
}

.author-list p {
  font-weight: 600;
  margin-bottom: 4px;
}

.author-list input,
.sub-type input {
  width: 100%;
  height: 35px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding-left: 15px;
  box-sizing: border-box;
}

.author-btn {
  display: inline-block;
  padding: 8px 20px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 3px;
  cursor: pointer;
  margin-bottom: 20px;
  color: #fff;
  background-color: #5bc0de;
  border-color: #46b8da;
}

.sub-type {
  margin-bottom: 20px;
}

.sub-type p {
  margin-bottom: 5px;
  font-weight: 600;
}

.sub-type textarea {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px;
  box-sizing: border-box;
}

.upload-btn {
  margin-top: 20px;
  margin-bottom: 20px;
}

.yellow-tip {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
  color: #8a6d3b;
  margin-top: 20px;
  background-color: #fcf8e3;
  border-color: #faebcc;
}

.sub-mit {
  width: auto;
  display: inline-block;
  padding: 10px 46px;
  cursor: pointer;
  font-size: 18px;
  line-height: 1.33;
  border-radius: 6px;
  color: #fff;
  background-color: #428bca;
  border-color: #357ebd;
}

.w-100 {
  width: 100%;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .author-lists {
    display: block;
  }

  .author-list {
    width: 100%;
    margin: 20px 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/bank.vue